import { inject, Injectable } from '@angular/core';
import { map } from 'rxjs';
import { CookieDomainQuery } from '../queries/generated';

@Injectable({
  providedIn: 'root'
})
export class PublicGraphqlService {
  private readonly cookieDomainQuery = inject(CookieDomainQuery);

  cookieDomain$ = this.cookieDomainQuery.fetch().pipe(map(({ data }) => data.public.cookieDomain));
}
